module.exports = __webpack_public_path__ + "static/media/jindou.04c0fa60.png";